import { AuthProvider } from "react-auth-kit";
import { useRecoilState } from "recoil";
import { v4 as uuidv4 } from "uuid";
import { signInState } from "./sign-in/SignIn.state";
import getRefreshApi from "./lib/useRefreshApi";
import { AUTH_KEY } from "./consts/auth";
import ForceRefreshToken from "./ForceRefreshToken";
import { useEffect } from 'react'

const AppAuthProvider = ({ children }) => {
  // Wrap AuthProvider in a new component
  // so that it can consume recoil states
  const [signInKey, setSignIn] = useRecoilState(signInState);
  const refreshApi = getRefreshApi({ signInKey });

  useEffect(() => {
    const updater = () => {
      if (localStorage.getItem(AUTH_KEY)) {
        setSignIn(uuidv4());
      }
    };

    window.addEventListener("auth-storage", updater);
    return () => {
      window.removeEventListener("auth-storage", updater);
    };
  }, [setSignIn]);

  return (
    <AuthProvider
      key={signInKey}
      authType="localstorage"
      authName={AUTH_KEY}
      refresh={refreshApi}
    >
      {children}
      <ForceRefreshToken />
    </AuthProvider>
  );
};

export default AppAuthProvider;
